<script>
import CrmAccountContacts from '@/views/Application/CustomerService/Accounts/Account/Contacts'

export default {
  extends: CrmAccountContacts,
  data () {
    return {
      breadcrumb: {
        name: 'All Contacts',
        route: { name: 'sales-accounts-account-contacts', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>
